import script from "./template.vue?vue&type=script&setup=true&lang=js"
export * from "./template.vue?vue&type=script&setup=true&lang=js"

import "./template.vue?vue&type=style&index=0&id=6f8ea103&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f8ea103"]])

export default __exports__